import React from 'react';
import PostcodeValidator from '../../../../validator/postcode_validator';
import Input from '../../form/input';
import Translation from '../../translation/translation';
import TranslationContainer from '../../translation/translation_container';
import { generateClassName } from '../../../../_modules/helper/generate_class_name';
import PostcodeAutocomplete, { showAutoCompletePostcodeSelector } from '../../PostcodeAutocomplete';
import getTranslatedText from '../../../helper/get_translated_text';
import { loadGoogleMapDependencies } from '../../../../_global/initGoogleMapDependencies';

const lazyContainerClassNames = generateClassName({
    'fsf__usage-description': true,
    'usage-description': true,
    'ud-description--standalone': ({ standAlone }) => standAlone,
    'ud-description--inside-lightbox': ({ standAlone }) => !standAlone,
});

const lazyFormClassNames = generateClassName({
    'ud-launch-app__choose-postcode': true,
    'postcode-form': true,
    'has-validation-error': ({ postcodeInvalid }) => postcodeInvalid,
});

class UsageDescriptionComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = { postcode: '' };

        this.onSubmit = this.onSubmit.bind(this);
        this.onPostcodeInputChange = this.onPostcodeInputChange.bind(this);
        this.showAutoCompletePostcode = showAutoCompletePostcodeSelector(this.props.store);
    }

    onPostcodeInputChange(e) {
        const postcode = e.target.value;

        if (this.props.standAlone) {
            this.setState({ postcode });
        } else {
            this.props.onPostcodeUpdate(postcode);
        }
    }

    onSubmit(e) {
        if (this.props.standAlone) {
            e.preventDefault();
        }
        loadGoogleMapDependencies();
        const payload = this.props.standAlone ? this.state.postcode : e;
        if (e) {
            e.preventDefault();
        }
        TYROOLA.mapsInitiated.then(() => {
            this.props.onPostcodeSubmit(payload);
        });
        if (this.props.standAlone) {
            return false;
        }
    }

    isValid(postcode) {
        if (!postcode || postcode === '') return false;
        return this.props.standAlone ?
            !this.props.validateAutocompleteInput(postcode) :
            this.props.postcodeInvalid;
    }

    render() {
        const props = this.props;
        const postcode = this.props.standAlone ? this.state.postcode : this.props.postcode;
        const formClassNames = lazyFormClassNames({
            postcodeInvalid: this.isValid(postcode)
        });

        return (
            <section className={lazyContainerClassNames(props)} ref="container">
                <header className="usage-description__header ud-header">
                    <h2 className="ud-header__headline">
                        <Translation translationKey="fitting-station-finder-how-it-works-headline" />
                    </h2>
                </header>
                <main className="usage-description__content ud-content">
                    <div className="ud-content__step">
                        <div className="ud-content__icon-container">
                            <span className="ud-content__icon ud-content__icon--selection" />
                        </div>
                        <div className="ud-content__text">
                            <p className="ud-content__description">
                                <Translation translationKey="fitting-station-finder-how-it-works-select-fitter" />
                            </p>
                            <p className="ud-content__description ud-content__description--additional-info">
                                <Translation translationKey="fitting-station-finder-how-it-works-price" />
                            </p>
                        </div>
                    </div>
                    <div className="ud-content__step">
                        <div className="ud-content__icon-container">
                            <span className="ud-content__icon ud-content__icon--shipping" />
                        </div>
                        <div className="ud-content__text">
                            <p className="ud-content__description">
                                <Translation translationKey="fitting-station-finder-how-it-works-ship-directly" />
                            </p>
                        </div>
                    </div>
                    <div className="ud-content__step">
                        <div className="ud-content__icon-container">
                            <span className="ud-content__icon ud-content__icon--contact" />
                        </div>
                        <div className="ud-content__text">
                            <p className="ud-content__description">
                                <Translation translationKey="fitting-station-finder-how-it-works-arrange-fitting" />
                            </p>
                            <p className="ud-content__description ud-content__description--additional-info">
                                <Translation translationKey="fitting-station-finder-how-it-works-quick-delivery" />
                            </p>
                        </div>
                    </div>
                </main>
                <footer className="usage-description__launch-fsf-app ud-launch-app">
                    <h3 className="ud-launch-app__headline">
                        <Translation translationKey="fitting-station-finder-how-it-works-find-fitter" />
                    </h3>
                    <form
                        className={formClassNames}
                        onSubmit={this.onSubmit}
                    >
                        {
                            !this.showAutoCompletePostcode && <TranslationContainer translationKey="form-placeholder-postcode" targetProperty="placeholder">
                                <input
                                    className="ud-launch-app__postcode-input postcode-form__input"
                                    type="text"
                                    value={postcode}
                                    onChange={this.onPostcodeInputChange}
                                />
                            </TranslationContainer>
                        }

                        {
                            this.showAutoCompletePostcode && <PostcodeAutocomplete value={postcode}
                                position="bottom"
                                onChange={this.onPostcodeInputChange}
                                name="postcode"
                                selectSuggestion={props.selectPostcodeSuggestion}
                                native>
                                <input
                                    className="ud-launch-app__postcode-input postcode-form__input"
                                    type="text"
                                    value={postcode}
                                    onChange={this.onPostcodeInputChange}
                                    placeholder={getTranslatedText('form-placeholder-postcode')}
                                    autoComplete="off"
                                />
                            </PostcodeAutocomplete>
                        }
                        <div className="postcode-error-msg postcode-form__error-msg">
                            <span className="postcode-error-msg__label">
                                {props.postcodeInvalidMessage}
                            </span>
                        </div>
                        <input className="postcode-form__submit" type="submit" value="Continue" />
                    </form>
                    <span className="text-danger" id="addressNotFound"></span>
                </footer>
            </section>
        );
    }
}

export default UsageDescriptionComponent;
